import isEmpty from 'lodash/isEmpty';

export const selectCurrentUser = state => (state ? state.user : null);
export const selectIsSignedIn = state => !isEmpty(selectCurrentUser(state));
